/**
 * Today's frogs panel for the home view. Compact list of tasks the
 * user frogged for today. Mark them done from the task slide-over.
 *
 * Reference: spec section 15.10, design README section 5.1 panel `06`.
 */

import type { WireFroggedTask } from '@/lib/api/sales';
import { useSlideOver } from '@/lib/slide-over';

interface FrogsProps {
  tasks: WireFroggedTask[];
}

export function Frogs({ tasks }: FrogsProps) {
  const openSlideOver = useSlideOver((s) => s.open);
  return (
    <section className="border border-mx-grey-800 bg-mx-card p-mx-4">
      <p className="mono-label text-mx-grey-mid">
        <span className="num">06</span>
        Today&rsquo;s frogs
      </p>
      {tasks.length === 0 ? (
        <p className="mt-mx-3 text-mx-body-sm text-mx-grey-mid">
          No frogged tasks for today. Frog a task from the board to surface it here.
        </p>
      ) : (
        <ul className="mt-mx-3 flex flex-col">
          {tasks.map((task) => (
            <li key={task.id} className="border-t border-mx-grey-800 first:border-t-0">
              <button
                type="button"
                onClick={() => openSlideOver({ kind: 'task', taskId: task.id })}
                className="flex w-full items-center gap-mx-3 py-mx-2 text-left"
              >
                <span className="mono-label w-[80px] text-mx-grey-mid">{task.type}</span>
                <span className="flex-1 text-mx-body-sm text-mx-grey-300">{task.title}</span>
                <span className="mono-label text-mx-grey-mid">{task.priority}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
